import React from "react"
import PropTypes from "prop-types"
import Loading from "@irati/ui/src/Loading"
import StyledDealsLoader from "./styled/DealsLoader"

import "./styles/LoadingDeals.css"

const LoadingDeals = ({load, blur, children}) => {
  return (
    <Loading load={load} useLoader={false}>
      <StyledDealsLoader isLoading={!!load && blur}>{children}</StyledDealsLoader>
    </Loading>
  )
}

LoadingDeals.defaultProps = {
  children: null,
  load: null,
  blur: true
}

LoadingDeals.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  blur: PropTypes.bool,
  load: PropTypes.object
}

export default LoadingDeals
